//package imports
import React, { useEffect, useState, useRef } from "react";
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';



const ShareValueEdit = (props) => {
    const { imgvalue, close, open,  from, Continue,height, data, onClickAction,blur} = props;
    const [shareFromValue,setShareFromValue]=useState("")
    const [shareToValue,setShareToValue]=useState("")
    const [shareValue,setShareValue]=useState("")

    const modalRef = useRef();

    useEffect(() => {
        if (data !== undefined || data !== "") {
          setShareFromValue(data?.from_)
          setShareToValue(data?.to_)
          setShareValue(data?.value)
        }
    }, [data]);


    const reqbody = {
            id: data?.id,
            from_: shareFromValue,
            to_: shareToValue,
            value: shareValue
    }

    

    //function for handle modal backDrop Click
    const handleBackdropClick = (e) => {
        if (modalRef.current && !modalRef.current.contains(e.target)) {
            // Handle the click outside the modal (e.g., prevent closing the modal)
            e.preventDefault();
            e.stopPropagation();
        }
    };


    const buttonStyle = {
        backgroundColor: "#0A2FB6", // Set your desired background color
        color: 'white', // Set the text color if needed
        borderRadius:"16px"
    };


    const handleShareFrom = (e) => {
        let Value = e.target.value;
        if (Value.length === 1 && Value[0] === ' ') {
            // setInputValue(newInputValue);
            setShareFromValue("");
        } else {
            setShareFromValue(Value)
        }
    };

    const handleShareTo = (e) => {
        let Value = e.target.value;
        if (Value.length === 1 && Value[0] === ' ') {
            // setInputValue(newInputValue);
            setShareToValue("");
        } else {
            setShareToValue(Value)
        }
    };

    const handleOnValue = (e) => {
        let Value = e.target.value;
        if (Value.length === 1 && Value[0] === ' ') {
            // setInputValue(newInputValue);
            setShareValue("");
        } else {
            setShareValue(Value)
        }
    };

    //functiona call update share value
    const onClickUpdateSave = () => {
        onClickAction(reqbody)
    }

    //function call to close modal
    const modalClose = () => {
        setShareFromValue(data?.from_)
        setShareToValue(data?.to_)
        setShareValue(data?.value)
        close()
    }



    return (
        <Modal show={open} onHide={modalClose} aria-labelledby="contained-modal-title-vcenter"
            centered size={from === "SupportModal" ? "lg" : "md"} backdrop="static" onClick={imgvalue != undefined ? null : handleBackdropClick}  >
           <div class={blur ?"blurBackground": ""} >
            <Modal.Header style={{ backgroundColor: "#0A2FB6", color: "white" }} data-bs-theme="dark" closeButton>
                <h6 class="text-white fw-bold m-0 montserrat">Edit</h6>
            </Modal.Header>
            <div style={{ height: `${height}`, borderRadius: "24px" }} class="mt-2">
                <Modal.Body class="text-center p-4">
                                <div>
                                    <div class="mb-3">
                                        <h6 class="text-start fs-5 m-0">Shares from</h6>
                                      
                                        <input class="form-control form-control-lg" type="text" name="shareFrom" placeholder="Value" value={shareFromValue} aria-label="default input example" onChange={(e) => { handleShareFrom(e) }} ></input>
                                    </div>
                                    <div class="mb-3" >
                                    <h6 class="text-start fs-5 m-0">Shares to</h6>
                                        <input class="form-control form-control-lg" type="text" name="shareTo" placeholder="Value" value={shareToValue} aria-label="default input example" onChange={(e) => { handleShareTo(e) }}></input>
                                    </div>
                                    <div class="mb-3" >
                                    <h6 class="text-start fs-5 m-0">Shares Value</h6>
                                        <input class="form-control form-control-lg" type="text" name="Value" placeholder="Value" value={shareValue} aria-label="default input example" onChange={(e) => { handleOnValue(e) }}></input>
                                    </div>
                                </div>

                    
                </Modal.Body>
                {
                    <Modal.Footer class="d-flex justify-content-around align-self-center">
                        <Button className="px-3 py-2 my-1" onClick={onClickUpdateSave} style={buttonStyle}>
                            Save
                        </Button>
                    </Modal.Footer>
                }
            </div>
            </div>
        </Modal>
    )
}

export default ShareValueEdit